import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-privacy',
  imports: [RouterLink],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyComponent {
  effectiveDate: string = 'January 20, 2025';
  lastUpdated: string = 'September 20, 2025';

  constructor() {}

  ngOnInit(): void {}

  printPolicy(): void {
    window.print();
  }

  scrollToContact(event: Event): void {
    event.preventDefault();
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      contactElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
